export default __webpack_public_path__ + "static/control-2f7678c0543f8b2d9bd142dc0e89cd71.svg";